import api from '../lib/api';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from './ui/alert-dialog';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';

const DangerZoneCard = ({ onAccountDeleted }) => {
  const handleDeleteAccount = async () => {
    try {
      await api.delete('/user/account');
      toast.success('Account deleted successfully');
      onAccountDeleted();
    } catch {
      toast.error('Failed to delete account');
    }
  };

  return (
    <Card className="card-surface border-[#EF4444]" data-testid="danger-zone-card">
      <CardHeader>
        <CardTitle className="text-[#EF4444]" style={{ fontFamily: 'Outfit' }}>Danger Zone</CardTitle>
        <CardDescription>Irreversible actions</CardDescription>
      </CardHeader>
      <CardContent>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="destructive" className="rounded-full" data-testid="delete-account-button">
              <Trash2 className="w-4 h-4 mr-2" />Delete Account
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-[#121212] border-[#27272A]">
            <AlertDialogHeader>
              <AlertDialogTitle className="text-[#F9FAFB]">Are you absolutely sure?</AlertDialogTitle>
              <AlertDialogDescription className="text-[#A1A1AA]">This action cannot be undone. This will permanently delete your account and remove all your data from our servers.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="bg-[#27272A] text-[#F9FAFB] border-[#27272A]" data-testid="cancel-delete-button">Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDeleteAccount} className="bg-[#EF4444] text-[#F9FAFB] hover:bg-[#DC2626]" data-testid="confirm-delete-button">Delete Account</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </CardContent>
    </Card>
  );
};

export default DangerZoneCard;
